/**
 * Builds channel list props by conversation mode so rendering code stays declarative.
 */
export const buildCustomChannelListProps = ({
  internalTabActive,
  externalTabActive,
  filteredOffices,
  filteredRoleIds,
  staffDesignationIdsByUserId,
  staffRoleLookupBusy,
  selectedOwner,
  doctorChatCheckExistInProps,
  doctorChatCheck,
  setAllChannelsOfficesForDoctor,
  searchText,
  setCurrentChannel,
  isFromPatientChat,
}) => {
  if (internalTabActive) {
    return {
      filteredOffices,
      filteredRoleIds,
      staffDesignationIdsByUserId,
      staffRoleLookupBusy,
      internalTabActive,
    };
  }

  if (externalTabActive !== undefined) {
    return { externalTabActive, selectedOwner };
  }

  if (doctorChatCheckExistInProps) {
    return {
      filteredOffices,
      doctorChatCheck,
      setAllChannelsOfficesForDoctor,
      searchText,
      setCurrentChannel,
      isFromPatientChat,
    };
  }

  return { isFromPatientChat };
};

export const buildCustomChannelListHeaderProps = ({
  internalTabActive,
  externalTabActive,
  doctorChatCheckExistInProps,
  doctorChatCheck,
  allChannelsOfficesForDoctor,
  filteredOffices,
  searchText,
  setSearchText,
  selectedOption,
  setSelectedOption,
  handleRequestStatusFilter,
  setFilteredOfficesForNew,
  filteredOfficesForNew,
}) => {
  if (internalTabActive) {
    return {
      filteredOffices,
      selectedOption,
      setSelectedOption,
    };
  }

  if (externalTabActive !== undefined) {
    return { externalTabActive };
  }

  if (doctorChatCheckExistInProps) {
    return {
      doctorChatCheck,
      allChannelsOfficesForDoctor,
      filteredOffices,
      isPatientConversation: true,
      searchText,
      setSearchText,
      selectedOption,
      setSelectedOption,
      handleRequestStatusFilter,
      setFilteredOfficesForNew,
      filteredOfficesForNew,
    };
  }

  return null;
};

export const buildCustomConversationHeaderProps = ({
  externalTabActive,
  doctorChatCheckExistInProps,
  doctorChatCheck,
  setViewAppointmentCred,
}) => {
  if (externalTabActive !== undefined) {
    return { externalTabActive };
  }

  if (doctorChatCheckExistInProps) {
    return {
      doctorChatCheck,
      isFromPatientChat: true,
      setViewAppointmentCred,
    };
  }

  return null;
};

export const resolveNoChatDetail = ({
  t,
  internalTabActive,
  externalTabActive,
  doctorChatCheck,
}) => {
  if (internalTabActive) {
    return t("messenger.pleaseInternalSelectConversationToStart");
  }
  if (externalTabActive) {
    return t("messenger.pleaseExternalSelectConversationToStart");
  }
  if (doctorChatCheck) {
    return t("messenger.pleaseDoctorSelectConversationToStart");
  }
  return t("messenger.pleasePatientSelectConversationToStart");
};

export const applySelectionChanges = (previousState, officeOption, event) => {
  if (!officeOption.value) {
    return {
      ...previousState,
      selection: previousState.selection.map((entry) => ({
        ...entry,
        isChecked: false,
      })),
    };
  }

  const nextValue = {
    event,
    id: officeOption.value,
    isChecked: event.target.checked,
  };

  const existingIndex = previousState.selection.findIndex(
    (entry) => entry.id === officeOption.value,
  );
  if (existingIndex !== -1) {
    return {
      ...previousState,
      selection: previousState.selection.map((entry, index) =>
        index === existingIndex ? nextValue : entry,
      ),
    };
  }

  return {
    ...previousState,
    selection: [...previousState.selection, nextValue],
  };
};
